import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { colors } from '../../../../utilities/colors'
import UnitRow from '../../Units/UnitRow'
import GatePassField from './GatePassField'

export default function OrderVehiclesStep({ stepRef, vehicles, gatePasses, setGatePasses }) {
  const { t } = useTranslation()

  if (stepRef) stepRef.current = { isValid: () => true }

  return (
    <Box display="flex" flexDirection="column" w="full" gap={2}>
      <Text fontSize="sm" color={colors.grey300} textAlign="center">
        {t('Confirm your vehicles')}
      </Text>

      <Box w="full" display="flex" flexDirection="column" gap={2}>
        {vehicles.map((vehicle) => {
          const unit = {
            id: vehicle.vin,
            attributes: {
              year: vehicle.year,
              make: vehicle.make,
              model: vehicle.model,
              vin: vehicle.vin,
            },
          }
          const hasGatePass = !!gatePasses?.[vehicle.vin]
          return (
            <Box
              key={unit.id}
              borderRadius="md"
              border="1px solid"
              borderColor={hasGatePass ? colors.green : colors.grey700}
              overflow="hidden"
            >
              <UnitRow
                unit={unit}
                trailing={
                  <GatePassField
                    vehicleId={vehicle.vin}
                    gatePasses={gatePasses}
                    setGatePasses={setGatePasses}
                  />
                }
              />
            </Box>
          )
        })}
      </Box>

      <Box mt={1} px={3} py={2} borderRadius="md" borderLeft="3px solid" borderLeftColor={colors.yellow} bg={`${colors.yellow}22`}>
        <Text fontSize="xs" color={colors.grey100}>
          {t(
            'It is the customer’s responsibility to provide a gate pass when one is required for pickup. If the transporter arrives at the pickup location without a valid gate pass, the order will be canceled and the customer will still be charged in full.'
          )}
        </Text>
      </Box>
    </Box>
  )
}
